const RestaurantTimeIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#EC4899"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.5556 9.65H9.66667V3H7.77778V9.65H5.88889V3H4V9.65C4 11.664 5.56778 13.298 7.54167 13.4215V22H9.90278V13.4215C11.8767 13.298 13.4444 11.664 13.4444 9.65V3H11.5556V9.65ZM16.2778 6.8V14.4H18.6389V22H21V3C18.3933 3 16.2778 5.128 16.2778 6.8Z" />
  </svg>
)

export default RestaurantTimeIcon
